import type { GraphicsQuality } from "../render/scene";

/**
 * Reglage de qualite graphique, stocke a part du reste des preferences (`menuSettings.ts`)
 * sous une cle PARTAGEE entre tous les jeux du Taverneux (echecs, othello, dames,
 * bataille, farkle) : choisi dans l'un, il s'applique aussitot aux autres, tant qu'ils
 * sont servis depuis la meme origine (le stockage local est par origine, pas par jeu).
 * Ne pas renommer cette cle sans repercuter le changement dans tous les autres jeux.
 */
const STORAGE_KEY = "dkg-taverne:graphics-quality:v1";

const VALID_QUALITIES: readonly GraphicsQuality[] = ["high", "standard", "battery"];

/** Ecran tactile (mobile/tablette) = par defaut le niveau "Economie" : c'est la que
 * l'ecart de rendu avec "Standard" se remarque le moins, et ou reduire la charge
 * GPU importe le plus (peu de marge thermique/batterie sur ces appareils). */
function defaultGraphicsQuality(): GraphicsQuality {
  try {
    return window.matchMedia("(pointer: coarse)").matches ? "battery" : "standard";
  } catch {
    return "standard";
  }
}

export function loadGraphicsQuality(): GraphicsQuality {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw && (VALID_QUALITIES as readonly string[]).includes(raw)) return raw as GraphicsQuality;
  } catch {
    // Stockage indisponible (navigation privee, quota...) : tant pis, pas bloquant.
  }
  return defaultGraphicsQuality();
}

export function saveGraphicsQuality(quality: GraphicsQuality): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, quality);
  } catch {
    // idem
  }
}
